import { type AxiosResponse } from 'axios';
import { get, post, put } from '@utilities';

import {
	ICreateFeedbackRequest,
	ICreateFeedbackResponse,
	IFetchAllFeedbackRequest,
	IFetchAllFeedbackResponse,
	IFeedbackResponse
} from './interfaces';

const BASE_URL = 'feedback';

export const createFeedback = async (payload: ICreateFeedbackRequest): Promise<AxiosResponse> =>
	await post(BASE_URL, payload);

export const fetchAllFeedback = async (payload: IFetchAllFeedbackRequest): Promise<AxiosResponse> =>
	await post(`${BASE_URL}/all`, payload);

export const getFeedbackById = async (feedbackId: number): Promise<AxiosResponse> =>
	await get(`${BASE_URL}/${feedbackId}`);

export const resolveFeedback = async (feedbackId: number): Promise<AxiosResponse> =>
	await put(`${BASE_URL}/${feedbackId}/resolve`, {});

export const uploadDocument = async (body: any): Promise<AxiosResponse> =>
	await post('document/upload', body);

export const activateDocument = async (data: { documentIds: number[] }): Promise<AxiosResponse> =>
	await post('document/activate', data);
